import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from 'app/global/global.service';
import {HelperService} from 'app/main/pages/edit-template/helper.service';
import {InviteToSignService} from './invite-to-sign.service';

// import { ParseNamePipe } from 'app/pipes/parse-name.pipe';


@Component({
  selector: 'app-invite-to-sign',
  templateUrl: './invite-to-sign.component.html',
  styleUrl: './invite-to-sign.component.scss'
})
export class InviteToSignComponent implements OnInit {
  
  @Input() roleId:number;
  @Input() document_id:number;
  @Input() is_sender:number;
  
  public inviteToSign: FormGroup;
  public invitationThrough: Array<{id: number, name: string, value: string}> = [
    { id: 1, name: 'Email', value: 'email'},
    { id: 2, name: 'Email and SMS', value: 'email_and_sms' },
    { id: 3, name: 'SMS', value: 'sms' }
  ];
  public submitted:boolean = false;
  public inviteToSignLoader:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private globalService: GlobalService,
    private helperService: HelperService,
    public activeModal: NgbActiveModal,
    private inviteToSignService: InviteToSignService,
  ){}

  ngOnInit(): void {
    this.initForm();  
  }

  initForm(){
    this.inviteToSign = this.formBuilder.group({
      recipient : this.formBuilder.group({
        firstname : ['',Validators.required],
        lastname : [''],
        email: ['', [Validators.required, Validators.email]],
        phone_no : [''],
        persnol_no : [''],
        address : [''],
        city : [''],
        zipcode : ['']
      }),
      invitation_type: ['email'],
      message: ['']
    })
  }

  onSubmit() {
    this.submitted = true;
    if (this.inviteToSign.invalid) return;

    this.inviteToSignLoader = true;
    this.inviteToSignService.inviteToSign(this.roleId, this.document_id ,this.newRole()).subscribe(
      {
        next : () => {
          window.location.reload();
        },
        error : (error) => {
          this.globalService.toastrError(error);
          this.inviteToSignLoader = false;
          this.submitted = false;
        }
      }
    )
  }




 /**
   * Get form value behalf on key
   * @param key 
   * @returns Form value
   */
  getFilteredForm(key: string){
    const formData = {...this.inviteToSign.value};
    if(formData?.recipient?.phone_no){
      formData.recipient.phone_no = formData?.recipient?.phone_no?.e164Number;
    }
    return key ? formData[key] : formData;
  }



  newRole(){
      const newRole = this.formBuilder.group({
        document_id: this.document_id,
        role_name: [`Recipient 1`],
        role_color: this.globalService.generateRandomColor(),
        sender_as_role: [0],
        recipient_id: [null],
        organization_id: [null],
        invitation_type: [this.inviteToSign.value.invitation_type],
        invitation_order: [1],
        authentication_type: ['e_signature'],
        authentication_required: [true],
        confirmation_type: ['email'],
        signature_confirmation: [''],
        personfields: this.formBuilder.array(this.helperService.getPersonfields([], this.getFilteredForm('recipient'), false, false)),
        orgfields: this.formBuilder.array(this.helperService.getOrgfields([], {}, false, false)),
        recipient: this.getFilteredForm('recipient'),
        organization: null,
        message: this.getFilteredForm('message')
    });
    return newRole.value;
  }


  /**
   * On change invitation making phone number required
   * @param type 
   */
  onChangeInvitation(type:{value:string}){
    const phone_no = <FormControl>this.inviteToSign.get('recipient.phone_no');
    phone_no.setValidators(["email_and_sms", "sms"].includes(type.value) 
      ? [Validators.required] 
      : null
    );
    phone_no.updateValueAndValidity();
  }
}
